import { Link } from "react-router-dom";

import withLayoutSimple from "../../components/withLayoutSimple/withLayoutSimple";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageCousinF.module.scss";

function PageCousinF() {
  const getImgSet = useImgSet();

  const content = getImgSet("content__p35", "jpg", s.content);

  const back = getImgSet("back__p22", "png");
  const imgA = getImgSet("bear__04__alt", "png", s.img__a);
  const imgB = getImgSet("bear__05__alt", "png", s.img__b);

  return (
    <div className={s.root}>
      <div className={s.aside_left}>
        {imgA}
        {imgB}
      </div>
      <div className={s.inner}>
        {content}
        <Link to="/cousin/d" className={s.back}>
          {back}
        </Link>
      </div>
    </div>
  );
}

export default withLayoutSimple(PageCousinF, false, false, true, false);
